import { ArticleHeading1, ArticleHeading3, ArticleParagraph1 } from '@cian/ui-kit';

import { Wrapper } from '../Wrapper';
import { content } from './content';

import * as styles from './styles.css';

export const HowItWorks: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['title']}>
          <ArticleHeading1>Как это работает</ArticleHeading1>
        </div>
        <div className={styles['content']}>
          {content.map(item => {
            return (
              <div key={item.id} className={styles['content-item']}>
                <div className={styles['num']}>{item.id}</div>
                <div className={styles['content-title']}>
                  <ArticleHeading3>{item.title}</ArticleHeading3>
                </div>
                <ArticleParagraph1>{item.description}</ArticleParagraph1>
              </div>
            );
          })}
        </div>
      </Wrapper>
    </div>
  );
};

HowItWorks.displayName = 'HowItWorks';
